import { MutationTree } from 'vuex';
import { UserState } from './state';
import { ChimeraContractModel, ChimeraContractInfo } from '@/models/chimera/ChimeraContractModel';
import { ChimeraCourseInfo } from '@/models/chimera/ChimeraCourseModel';
import { DEFAULT_POSTGRAD_CONTRACT_DURATION } from '@/helpers/postgradContractExtension/constants';
import { getDiffTime } from '@/helpers/date';

const mutations: MutationTree<UserState> = {
  SET_CHIMERA_USER_MOST_RECENT_CONTRACT(state, chimeraCourses: ChimeraCourseInfo[]) {
    if (!chimeraCourses.length) return;

    const contractsFromCourse = chimeraCourses
      .map((course) => {
        if (course.category.slug === 'pos') return course.contractByUser;
        return null;
      })
      .filter(
        (contract) =>
          contract &&
          getDiffTime(contract.expirationDate, contract.startDate).months >=
            DEFAULT_POSTGRAD_CONTRACT_DURATION,
      ) as ChimeraContractInfo[];

    const contractsSortedByStartDate = contractsFromCourse.sort(
      (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
    );

    if (!contractsSortedByStartDate.length) return;
    const mostRecentContract = contractsSortedByStartDate[contractsSortedByStartDate.length - 1];

    state.mostRecentChimeraContract = new ChimeraContractModel(mostRecentContract);
  },
};

export default mutations;
